import { Link } from 'react-router-dom';

const features = [
  {
    title: '24/7 Guest Support',
    description: 'Round-the-clock communication with guests, handling inquiries, check-ins, and any issues that arise.'
  },
  {
    title: 'Professional Cleaning',
    description: 'Coordinated cleaning services between bookings to maintain 5-star cleanliness standards.'
  },
  {
    title: 'Revenue Analytics',
    description: 'Detailed reporting and insights to track performance, optimize pricing, and maximize your earnings.'
  }
];

export default function PropertyManagement() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-5 gap-12 items-center">
          {/* Image */}
          <div className="lg:col-span-3">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl h-[600px]">
              <img 
                src="https://public.readdy.ai/ai/img_res/7db790d67d632468b1da7e35bfb9307a.jpg"
                alt="Property Management"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Content */}
          <div className="lg:col-span-2 bg-[#FAF8F5] rounded-3xl p-12">
            <div className="inline-block px-4 py-2 bg-[#FF6B6B] text-white text-sm font-semibold rounded-full mb-6">
              Full-Service Management
            </div>
            
            <h2 className="text-5xl font-bold text-[#1A2332] mb-8 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
              Focus on Life,<br />We'll Handle the Rest
            </h2>

            <div className="space-y-6 mb-10">
              {features.map((feature, index) => (
                <div key={index} className="flex gap-4">
                  <div className="flex-shrink-0 w-8 h-8 bg-[#FF6B6B] rounded-full flex items-center justify-center">
                    <i className="ri-check-line text-white text-lg"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-[#1A2332] mb-2">
                      {feature.title}
                    </h3>
                    <p className="text-gray-600">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <Link 
              to="/services#management"
              className="inline-flex items-center bg-[#FF6B6B] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#ff5252] transition-all hover:shadow-lg cursor-pointer whitespace-nowrap mb-4"
            >
              Explore Management Plans
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>

            <div>
              <Link to="/contact" className="text-[#1A2332] hover:text-[#FF6B6B] transition-colors text-sm cursor-pointer">
                See pricing details →
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
